import styled from 'styled-components/macro'

const SearchResultDescription = styled.p`
  color: #4a4a4a;
`

export default SearchResultDescription
